import { NgModule } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import {InfrastructureApiService} from './infrastructure-api.service';

@NgModule({
  imports: [
    ConfigManagerModule
  ],
  providers: [
    InfrastructureApiService,
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json'}},
  ]
})
export class SdkInfrastructureModule { }
